var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fileDisplay"},[_c('span',{staticClass:"fName"},[_vm._v(_vm._s(this.file.name))]),_c('span',{staticClass:"deleteBtn",on:{"click":_vm.deleteFile}},[_vm._v("삭제")])])
}
var staticRenderFns = []

export { render, staticRenderFns }